const STORAGE_KEY = 'recently_viewed_products';
const MAX_ITEMS = 10;

/**
 * Retrieves the array of recently viewed products from localStorage.
 */
export const getRecentlyViewed = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch (err) {
    console.error('Failed to parse recently viewed products', err);
    return [];
  }
};

/**
 * Adds a product to the top of recently viewed products in localStorage.
 * Prevents duplicates and limits list to MAX_ITEMS.
 */
export const addRecentlyViewed = (product) => {
  if (!product || !product.id) return;

  try {
    const list = getRecentlyViewed();
    // Filter out current product if already in list
    const filtered = list.filter((item) => item.id !== product.id);

    // Minimal product payload to store in LocalStorage
    const entry = {
      id: product.id,
      description: product.description,
      price: product.price,
      file: product.file,
      category: product.category,
      stockQuantity: product.stockQuantity,
      shipped: product.shipped,
      market: product.market ? { id: product.market.id, name: product.market.name } : null
    };

    const updated = [entry, ...filtered].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (err) {
    console.error('Failed to save recently viewed product', err);
  }
};
